export const HELP_MENU = {
  ITEMS: ['get_help', 'support', 'live_chat', 'whats_new'],
};

export const ACCOUNT_AND_USER_MENU = {
  ITEMS: ['change_password', 'log_out'],
};

export const APP_SWITCHER = {
  TABS: ['archiving', 'pcc', 'personal_archiving'],
};

export const UNREAD_NOTIFICATION_COUNT = {
  FORMAT: '0a',
};

export default {
  HELP_MENU,
  ACCOUNT_AND_USER_MENU,
  APP_SWITCHER,
  UNREAD_NOTIFICATION_COUNT,
};
